import React from 'react';
import { Layout } from 'antd';

import ColorLogoFull from 'Icons/LogoHorizontal';

const { Header } = Layout;

export const PUBLIC_TYPE = 'public';
export const HOME_URL =
  process.env.REACT_APP_FE_ENV === 'prod'
    ? 'https://app.searchlight.ai/'
    : 'https://qa-fe.searchlight.ai/';

function PublicUserNav() {
  return (
    <Header className="tw-flex tw-flex-row tw-h-[60px] tw-bg-white tw-border-b tw-items-center tw-px-8 tw-justify-between">
      <div className="tw-flex tw-flex-row tw-items-center">
        <a href={HOME_URL}>
          <ColorLogoFull width={88} height={24} />
        </a>
      </div>
      <a
        className="tw-text-primary tw-text-right tw-text-sm"
        href="https://form.typeform.com/to/dpLqGNf4"
        target="_blank"
        rel="noreferrer"
      >
        Want your own Searchlight? Click here.
      </a>
    </Header>
  );
}

export default PublicUserNav;
